"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.cateArr = void 0;
var cateArr = [{
  id: 2,
  name: '3D',
  children: [{
    id: 3,
    name: '动作游戏'
  }, {
    id: 4,
    name: '射击游戏'
  }, {
    id: 5,
    name: '冒险游戏'
  }, {
    id: 6,
    name: '角色扮演游戏'
  }, {
    id: 7,
    name: '策略游戏'
  }, {
    id: 8,
    name: '模拟游戏'
  }, {
    id: 9,
    name: '体育游戏'
  }, {
    id: 10,
    name: '赛车游戏'
  }, {
    id: 11,
    name: '格斗游戏'
  }, {
    id: 12,
    name: '解谜游戏'
  }, {
    id: 13,
    name: '音乐/节奏游戏'
  }, {
    id: 14,
    name: '休闲游戏'
  }, {
    id: 15,
    name: '卡牌游戏'
  }, {
    id: 16,
    name: '益智游戏'
  }, {
    id: 17,
    name: '恐怖游戏'
  }, {
    id: 18,
    name: '沙盒游戏'
  }, {
    id: 19,
    name: '大逃杀游戏'
  }, {
    id: 20,
    name: '多人在线战斗竞技场'
  }, {
    id: 21,
    name: '社交游戏'
  }, {
    id: 22,
    name: '文本游戏'
  }]
}];
exports.cateArr = cateArr;